import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import { RichTextField, Text, TextField, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import React, { useEffect, useState } from 'react';
import { sanitizeAndTruncate } from 'lib/utils';

type ShortDescriptionFieldWrapperProps = {
  textField: TextField | null;
  fallbackRichTextField?: RichTextField | null;
  stringLength?: number;
  className?: string;
};

const ShortDescriptionFieldWrapper: React.FC<ShortDescriptionFieldWrapperProps> = (props) => {
  const { textField, fallbackRichTextField, stringLength, className } = props;
  const { sitecoreContext } = useSitecoreContext();
  const [sanitizeAndTruncateText, SetSanitizeAndTruncateText] = useState('');
  const allowedLength = stringLength || 350;
  const textFieldValue = (textField?.value || '').toString();

  useEffect(() => {
    SetSanitizeAndTruncateText(sanitizeAndTruncate(textFieldValue, allowedLength));
  }, [textFieldValue]);

  return (
    <>
      {textField && sitecoreContext.pageEditing && <Text field={textField} encode={true} editable={true} />}
      {sanitizeAndTruncateText && !sitecoreContext.pageEditing && (
        <span dangerouslySetInnerHTML={{ __html: sanitizeAndTruncateText }} />
      )}

      {!sanitizeAndTruncateText && fallbackRichTextField && (
        <RichTextWrapper field={fallbackRichTextField} className={className} />
      )}
    </>
  );
};

export default ShortDescriptionFieldWrapper;
